import type { Page, PlottingContext } from "@pdfking/renderer-api"

export const PlotPage = (
  page: Page,
  partial: PlottingContext = {}
): Promise<Blob> =>
  import("../utils/Proxy").then(({ PlotPage }) => PlotPage(page, partial))
